import $ from 'jquery';

function initMerchCarousel( $carousel ) {
  const $slides = $carousel.find( '.merch-carousel__slide' );
  const $pages = $carousel.find( '.merch-carousel__page' );
  const $prev = $carousel.find( '.merch-carousel__button--prev' );
  const $next = $carousel.find( '.merch-carousel__button--next' );
  const totalPages = $slides.length;

  if ( totalPages <= 1 ) {
    return;
  }

  let currentPage = 1;

  const goToPage = ( page ) => {
    currentPage = Math.max( 1, Math.min( page, totalPages ) );

    $slides.removeClass( 'is-active' );
    $slides.filter( `[data-slide="${ currentPage }"]` ).addClass( 'is-active' );

    $pages.removeClass( 'is-active' ).attr( 'aria-current', 'false' );
    $pages.filter( `[data-page="${ currentPage }"]` ).addClass( 'is-active' ).attr( 'aria-current', 'true' );

    $prev.prop( 'disabled', currentPage === 1 );
    $next.prop( 'disabled', currentPage === totalPages );
  };

  $prev.on( 'click', function() {
    goToPage( currentPage - 1 );
  } );

  $next.on( 'click', function() {
    goToPage( currentPage + 1 );
  } );

  $pages.on( 'click', function() {
    goToPage( parseInt( $( this ).data( 'page' ), 10 ) );
  } );
}

function initMerchLightbox() {
  const $lightbox = $( '#merch-image-slider' );
  const $sliderInner = $( '#merch-slider-inner' );

  if ( ! $lightbox.length || $lightbox.data( 'merch-lightbox-init' ) ) {
    return;
  }

  $lightbox.data( 'merch-lightbox-init', true );

  const closeLightbox = () => {
    $( 'body' ).removeClass( 'no-scroll' );
    $( '.merch-lightbox-overlay' ).fadeOut( function() {
      $( this ).remove();
    } );
    $( '.merch-close-slider' ).remove();
    $lightbox.fadeOut();
  };

  const showSlide = ( index ) => {
    $sliderInner.find( '.slider-slide' ).hide().eq( index ).fadeIn();
  };

  const initializeLightbox = ( $carousel, startIndex ) => {
    let currentIndex = startIndex;
    $sliderInner.empty();

    $carousel.find( '.merch-carousel__image[data-image]' ).each( function() {
      const $trigger = $( this );
      const title = $trigger.data( 'title' ) || '';
      const description = $trigger.data( 'description' ) || '';
      const price = $trigger.data( 'price' ) || '';
      const captionParts = [
        title ? `<p class="headline-5 mb-8">${ title }</p>` : '',
        description ? `<p class="mb-8">${ description }</p>` : '',
        price ? `<p class="headline-6">${ price }</p>` : '',
      ].filter( Boolean ).join( '' );

      const slide = `
        <div class="slider-slide">
          <img src="${ $trigger.data( 'image' ) }" alt="${ $trigger.data( 'alt' ) || '' }">
          ${ captionParts ? `<div class="slider-caption">${ captionParts }</div>` : '' }
        </div>
      `;

      $sliderInner.append( slide );
    } );

    $lightbox.fadeIn();
    showSlide( currentIndex );

    $lightbox.find( '.slider-button-next' ).off( 'click' ).on( 'click', function( e ) {
      e.stopPropagation();
      const total = $sliderInner.find( '.slider-slide' ).length;
      currentIndex = ( currentIndex + 1 ) % total;
      showSlide( currentIndex );
    } );

    $lightbox.find( '.slider-button-prev' ).off( 'click' ).on( 'click', function( e ) {
      e.stopPropagation();
      const total = $sliderInner.find( '.slider-slide' ).length;
      currentIndex = ( currentIndex - 1 + total ) % total;
      showSlide( currentIndex );
    } );
  };

  $( '[data-merch-carousel]' ).on( 'click', '.merch-carousel__image[data-image]', function( e ) {
    e.preventDefault();
    e.stopPropagation();

    const $carousel = $( this ).closest( '[data-merch-carousel]' );
    const $images = $carousel.find( '.merch-carousel__image[data-image]' );
    const startIndex = $images.index( this );

    $( 'body' ).addClass( 'no-scroll' );
    $( '<div class="overlay merch-lightbox-overlay"></div>' ).appendTo( 'body' ).fadeIn();
    $( '<div class="close-slider merch-close-slider">&times;</div>' ).appendTo( 'body' ).fadeIn();

    initializeLightbox( $carousel, startIndex );
  } );

  $( 'body' ).on( 'click', '.merch-lightbox-overlay, .merch-close-slider', closeLightbox );
  $lightbox.on( 'click', '.slider-inner', closeLightbox );
}

$( function() {
  $( '[data-merch-carousel]' ).each( function() {
    initMerchCarousel( $( this ) );
  } );

  initMerchLightbox();
} );
